import { Component, OnInit, ViewChild, ElementRef, HostListener, Output, EventEmitter, Renderer2 } from '@angular/core';
import { SignedWaiver, ContactInfo, Guest, signWaiverGuest } from 'src/app/models/waiver';
import { WaiverService } from 'src/app/services/waiver.service';
import { StoreService } from 'src/app/services/store.service';
import { ToolsService } from 'src/app/services/tools.service';
import { NumberToWordsPipe } from 'src/app/pipes/number-to-words.pipe';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';
import { pages, CustomFieldType } from 'src/app/alv-enums';
import { CustomFields, optionValue } from 'src/app/models/custom-fields';

declare var $: any
@Component({
  selector: 'sign-waiver',
  templateUrl: './sign-waiver.component.html',
  styleUrls: ['./sign-waiver.component.scss']
})
export class SignWaiverComponent implements OnInit {
  @ViewChild('waiverBody') waiverBody: ElementRef;
  @ViewChild('description') description: ElementRef;
  @ViewChild('signaturePad') signaturePad: SignaturePadComponent;
  @Output() protected  waiverCompleted = new EventEmitter<void>();
  description1: string = "You must mark";
  description2: string = "checkboxes to complete";
  signeeGuest = new signWaiverGuest();
  get noOfCheckboxes(): number {
    let checkboxes = this.waiverBody && this.waiverBody.nativeElement && this.waiverBody.nativeElement.getElementsByClassName('checkbox-custom');
    if (checkboxes) {
      return checkboxes.length;
    }
    return 0;
  }
  get checkedCount(): number {
    let checkboxes = this.waiverBody && this.waiverBody.nativeElement && this.waiverBody.nativeElement.getElementsByClassName('checkbox-custom');
    if (checkboxes) {
      let checkedCount = 0;
      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked)
          checkedCount++;
      }
      return checkedCount;
    }
    return 0;
  }
  constructor(private waiverService: WaiverService, private storeService: StoreService, private toolsService: ToolsService
    ,private renderer:Renderer2) { }
  signWaiver: SignedWaiver = new SignedWaiver();

  ngOnInit() {
    this.waiverService.getSignWaiver(this.storeService.waiver.waiverId)
      .then(response => {
        this.toolsService.ProcessHttpResponse(response, () => {
          if (response.succeeded) {
            let waiverData = response.data;
            let currentWaiver = this.storeService.waiver;
            this.signWaiver = new SignedWaiver();
            this.signWaiver.birthDay = waiverData.birthDay;
            this.signWaiver.emailAddress = waiverData.emailAddress;
            this.signWaiver.guestAccountId = waiverData.guestAccountId;
            this.signWaiver.guests = waiverData.guests;
            this.signWaiver.invalidWaiverUrl = waiverData.invalidWaiverUrl;
            this.signWaiver.isDisplayEmailOptOut = waiverData.isDisplayEmailOptOut;
            this.signWaiver.isEmailForMarketing = waiverData.isEmailForMarketing;
            this.signWaiver.isMembershipPackageSaleOn = waiverData.isMembershipPackageSaleOn;
            this.signWaiver.isRequireAcknowledgement = waiverData.isRequireAcknowledgement;
            this.signWaiver.isSignerAcknowledge = waiverData.isSignerAcknowledge;
            this.signWaiver.membershipPackageSaleOffMessage = waiverData.membershipPackageSaleOffMessage;
            this.signWaiver.minAgeOfConsent = waiverData.minAgeOfConsent;
            this.signWaiver.parentBirthDay = waiverData.parentBirthDay;
            this.signWaiver.parentGuestId = waiverData.parentGuestId;
            this.signWaiver.phoneNumber = waiverData.phoneNumber;
            this.signWaiver.signedWaiverId = waiverData.signedWaiverId;
            this.signWaiver.signedWaiverIdList = waiverData.signedWaiverIdList;
            this.signWaiver.waiverText = waiverData.waiverText;

            this.signWaiver.waiverBody = waiverData.waiverBody;
            this.signWaiver.waiverId = waiverData.waiverId;
            this.signWaiver.waiverName = waiverData.waiverName;
            this.signWaiver.waiverSignConfig = waiverData.waiverSignConfig;

            //copy form data into signed waiver so we can pass it on submit
            this.signWaiver.emailAddress = currentWaiver.email;
            this.signWaiver.firstName = currentWaiver.signee.basicInfo.firstName;
            this.signWaiver.lastName = currentWaiver.signee.basicInfo.lastName;
            this.signWaiver.birthdate = new Date(currentWaiver.signee.basicInfo.bYear, currentWaiver.signee.basicInfo.bMonth, currentWaiver.signee.basicInfo.bDate)
            this.signWaiver.phoneNumber = currentWaiver.signee.contactInfo.phone;
            this.signWaiver.streetAddress = currentWaiver.waiverCustomFields.find(c=>c.fieldName == "Street Address") && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "Street Address").fieldValue;
            this.signWaiver.city = currentWaiver.waiverCustomFields.find(c=>c.fieldName == "City") && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "City").fieldValue;
            this.signWaiver.state = currentWaiver.waiverCustomFields.find(c=>c.fieldName == "State") && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "State").fieldValue;
            this.signWaiver.zipCode = currentWaiver.waiverCustomFields.find(c=>c.fieldName == "Zip Code") && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "Zip Code").fieldValue;
            this.signWaiver.guestAccountId = currentWaiver.signee.guestAccountId;
            let selectedGuests = currentWaiver.guests.filter(g => g.selected == true);
            this.signWaiver.guests = selectedGuests && selectedGuests.map(t => {
              var g = new signWaiverGuest();
              g.guestId = t.guestId;
              g.lastName = t.basicInfo.lastName;
              g.firstName = t.basicInfo.firstName;
              g.birthDate = t.basicInfo.birthDate.toDateString();
              g.waiverCustomFieldFilledFormList = t.customFields;
              return g;
            });
            this.signWaiver.waiverCustomFieldFilledFormList = this.storeService.waiver.waiverCustomFields;
            this.signeeGuest.guestAccountOwner = true;

            //add the signee guest with updated signature
            !this.signWaiver.guests && (this.signWaiver.guests = []);

            this.signeeGuest.guestId = this.storeService.waiver.signee.guestId;
            this.signeeGuest.firstName = this.storeService.waiver.signee.basicInfo.firstName;
            this.signeeGuest.lastName = this.storeService.waiver.signee.basicInfo.lastName;
            this.signeeGuest.birthDate = this.storeService.waiver.signee.basicInfo.birthDate && this.storeService.waiver.signee.basicInfo.birthDate.toDateString();
            this.signeeGuest.streetAddress = currentWaiver.waiverCustomFields && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "Street Address") && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "Street Address").fieldValue;
            this.signeeGuest.city = currentWaiver.waiverCustomFields && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "City") && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "City").fieldValue;
            this.signeeGuest.state = currentWaiver.waiverCustomFields && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "State") && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "State").fieldValue;
            this.signeeGuest.zipCode = currentWaiver.waiverCustomFields && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "Zip Code") && currentWaiver.waiverCustomFields.find(c=>c.fieldName == "Zip Code").fieldValue;
            
            this.signWaiver.guests.push(this.signeeGuest)

            this.signWaiver.waiverTemplateId = this.storeService.waiver.waiverId;
            this.signWaiver.waiverLogoUrl = this.storeService.waiver.waiverLogoUrl
            //Element Refs
            this.waiverBody.nativeElement.innerHTML = waiverData.waiverText;
            let noOfCheckboxes = this.waiverBody.nativeElement.getElementsByClassName("checkbox-custom").length;
            if(noOfCheckboxes > 0){
            this.description.nativeElement.innerHTML = `${this.description1} ${new NumberToWordsPipe().transform(noOfCheckboxes)} (${noOfCheckboxes}) ${this.description2}`;
            }
            else{
              this.description.nativeElement.style.display = 'none';
            }
            let checkboxes = this.waiverBody.nativeElement.getElementsByClassName("checkbox-custom");
            if(checkboxes)
            {
              for(var i=0;i<checkboxes.length;i++){
                this.renderer.setProperty(checkboxes[i],'outerHTML',`<label class="chkContainer mr-0"><input type="checkbox" class="checkbox-custom" name="checkform"  value="true"/><input type="hidden" name="checkform" value="false"/><span class="checkmark"></span></label>`);
              }
            }
          }
        })
      })
    $(document.body).on('touchmove', this.onScroll()); // for mobile
    $(window).on('scroll', this.onScroll);
  }
  

 

  onSubmit() {
    let self = this;
    this.signWaiver.pictureData = this.signaturePad.signature.replace("data:image/png;base64,","");
    this.signeeGuest.pictureData = this.signWaiver.pictureData;
    this.signeeGuest.birthDate = this.signWaiver.birthdate.toDateString();
    this.waiverService.submitSignWaiver(this.signWaiver)
      .then(response => {
        this.toolsService.ProcessHttpResponse(response, () => {
          if (response.succeeded == true) {
            this.storeService.shoppingCart.guestId = response.data;
            self.waiverCompleted.emit();
          }
          else {
            self.toolsService.showError('An unexpcted error occured in restting password');
          }
        })
      });
      window.scroll(0,0)
  }

  
  
  @HostListener('click', ['$event.target']) onClick(ctrl) {
    if (ctrl.className && ctrl.className.indexOf("checkbox-custom") > -1) {
      this.handleCheckboxes(ctrl);

    }
  }

  handleCheckboxes(element: any) {
    //Required Checkboxes
    let allcheckcount = this.noOfCheckboxes;
    this.onScroll();

  }

  onScroll() {
    var offset = $('.checkbox-custom:checkbox:not(:checked)');
    var marker = $('#fixed-button');
    var final = $('.final-level');
    if (typeof offset.offset() === "undefined")
      offset = final;

    if (marker && marker.offset() && marker.offset().top > offset.offset().top - 70) {
      $('.fa-arrow-circle-down').removeClass("rotate-left");
      $('.fa-arrow-circle-down').addClass("rotate");
    } else {
      $('.fa-arrow-circle-down').removeClass("rotate");
    }

    if (marker && marker.offset() && marker.offset().top + 100 >= final.offset().top) {
      $('.description-checked-box-float').hide();
      $('.description-checked-box').show();
    } else {
      $('.description-checked-box-float').show();
      $('.description-checked-box').hide();
    }
  }
}
